export const dashboardStyle = {
  wrapper: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',

    '@media (min-width: 1200px)': {
      minHeight: 'calc(100vh - 128px)',
      maxHeight: 'fit-content',
    },
  },

  modal: {
    '.MuiPaper-root': {
      position: 'relative',
      minWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      paddingTop: '48px',
      margin: '0 15px',
      borderRadius: '8px 8px 0 0 ',
    },

    '&.MuiDialog-root': {
      height: 'calc(100% - 80px)',
    },
  },

  emptyContent: {
    '& .MuiTypography-root': {
      maxWidth: '235px',
      width: '100%',
    },
  },

  loader: {
    position: 'absolute',
    left: '50%',
    top: '50%',
  },

  contentWrapper: {
    display: 'flex',
    gap: '16px',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
  },
};
